import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgingComponent } from './components/aging/aging.component';
import { AgingRoutingModule } from '@app/modules/aging/aging-routing.module';
import { RouterModule } from '@angular/router';
import { MenuToolbarModule } from '@app/modules/common/modules/menu-toolbar/menu-toolbar.module';
import { AgingSummaryHomeComponent } from './components/aging-summary/components/aging-summary-home/aging-summary-home.component';
import { LayoutHelpersModule } from '@layouts/layout-helpers/layout-helpers.module';
import { MaterialModule } from '@core/material/material.module';
import { RcpCommonLibraryModule } from '@core/modules/rcp-common-library/rcp-common-library.module';
import { ClaimSearchModule } from '@modules/claims/modules/claim-search/claim-search.module';
import { AgingClaimsSummaryComponent } from './components/aging-summary/components/aging-claims-summary/aging-claims-summary.component';
import { AgingWorklistSummaryComponent } from './components/aging-summary/components/aging-worklist-summary/aging-worklist-summary.component';
import { AgingLatestUploadSummaryComponent } from './components/aging-summary/components/aging-latest-upload-summary/aging-latest-upload-summary.component';
import { ClaimsHomeModule } from '@modules/claims/modules/claims-home/claims-home.module';
import { AgingTrendDetailMetricComponent } from '@modules/aging/components/aging-summary/components/aging-trend-detail-metric/aging-trend-detail-metric.component';
import { AgingTrendSummaryMetricComponent } from '@modules/aging/components/aging-summary/components/aging-trend-summary-metric/aging-trend-summary-metric.component';
import { ClaimProgressMetricComponent } from '@modules/aging/components/aging-summary/components/claim-progress-metric/claim-progress-metric.component';
import { NeverWorkedAgeMetricComponent } from '@modules/aging/components/aging-summary/components/never-worked-age-metric/never-worked-age-metric.component';
import { DaysToCompleteMetricComponent } from '@modules/aging/components/aging-summary/components/days-to-complete-metric/days-to-complete-metric.component';
import { StalledClaimFilterComponent } from '@modules/claims/components/stalled-claim-filter/stalled-claim-filter.component';

@NgModule({
    declarations: [
        AgingComponent,
        AgingSummaryHomeComponent,
        AgingClaimsSummaryComponent,
        AgingWorklistSummaryComponent,
        AgingLatestUploadSummaryComponent,
    ],
    imports: [
        CommonModule,
        AgingRoutingModule,
        RouterModule,
        MenuToolbarModule,
        LayoutHelpersModule,
        MaterialModule,
        RcpCommonLibraryModule,
        ClaimSearchModule,
        ClaimsHomeModule,
        AgingTrendDetailMetricComponent,
        AgingTrendSummaryMetricComponent,
        ClaimProgressMetricComponent,
        NeverWorkedAgeMetricComponent,
        DaysToCompleteMetricComponent,
        StalledClaimFilterComponent,
    ],
    exports: [AgingComponent],
})
export class AgingModule {}
